module.exports = __webpack_public_path__ + "static/media/B5.f034281e.jpg";